<template>
    <section>
        <div class="row">
            <div class="col-lg-12">
                <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                    <div class="sk-bounce1"></div>
                    <div class="sk-bounce2"></div>
                    <div class="sk-bounce3"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-right">
                <button @click="fetchOrders" style="margin-top: 25px" class=" btn btn-info btn-sm refresh_btn"><i class="fa fa-refresh"></i> Refresh</button>
            </div>
<!--          1==> assigned to branch-->
            <div v-if="orders.length === 0">
                <p class="text-center">
                  <strong>New Orders will land here....</strong>
                </p>
            </div>
            <div v-else>
              <div class="col-lg-6"  v-for="(order, index) in orders"
                   :key="'order-row-' + index">
                  <OrderRow :order="order" @viewOrder="showOrderDetails"/>
              </div>
            </div>
        </div>
        <ViewOrder :show-order-actions="true" @updateOrders="fetchOrders" ref="viewOrderCompNew"/>
    </section>
</template>

<script>
import ViewOrder from "./ViewOrder";
import OrderRow from "./OrderRow";

export default {
    name: "OrderNew",
    components: {
        ViewOrder,
        OrderRow
    },
    data() {
        return {
            statusesWithoutUnAssignedOrder: [],
            orders: [],
            isHideSpinner: "",
            branch_id: null,
            websocket: null,
        }
    },
    computed: {
        branch() {
            return this.$store.state.user.branch
        },
        newOrderId() {
            return this.$store.state.newOrderId
        },
        bellOn() {
            return this.$store.state.bellOn
        },
        updateBranchNewOrders() {
            return this.$store.state.updateBranchNewOrders
        },
        fetchOrderDetails() {
          return this.$store.getters.fetchOrderDetails;
        }
    },
    created() {
        this.statusesWithoutUnAssignedOrder = [
            this.$status.ASSIGNED_TO_BRANCH.id,
            this.$status.ACCEPTED_BY_BRANCH.id,
            this.$status.READY_FOR_PICKUP.id,
            this.$status.CANCELED.id
        ]
    },
    async mounted() {
      this.isHideSpinner = "";
      this.branch_id = this.$store.getters.user_branch.id;
      await this.fetchOrders();
      if (this.newOrderId !== null && this.fetchOrderDetails) {
        this.showOrderDetails(this.newOrderId);
        this.$store.commit('fetch_order_detail', false);
        this.$store.commit('new_order_id', null);
      }
      this.isHideSpinner = "hide";
    },
    watch: {
        newOrderId: async function () {
          await this.fetchOrders();
        },
      bellOn(val) {
        setTimeout(async () => {
          val && await this.$store.dispatch('keepRingingNotificationBell');
        }, 2000)
      },
        fetchOrderDetails: async function (){
          if(this.newOrderId !== null) {
            this.showOrderDetails(this.newOrderId);
            this.$store.commit('fetch_order_detail', false);
            this.$store.commit('new_order_id', null);
          }
        },
        updateBranchNewOrders: async function(value) {
            if(value) {
                await this.fetchOrders();
                this.$store.commit('update_branch_new_order', false);
            }
        },
        orders: function (){
          this.$store.dispatch('stopNotificationBell');
          for(let order of this.orders){
            if(order.statusesByStatusId.id === 7 || order.statusesByStatusId.id === 1 || order.statusesByStatusId.id === 9){
              this.$store.dispatch('keepRingingNotificationBell');
              break;
            }
          }
          // 7 ==> unassigned, 1==> assigned to branch, 9==> cancelled
        }
    },
    methods: {
        async fetchOrders() {
          await this.$store.dispatch('validateUserAndCreateWebsocketConnection');
          this.isHideSpinner = "";
          const payload = {
            status_id: this.statusesWithoutUnAssignedOrder,
            order_cancellation_acknowledgement: false,
            time_frame: 48,
            page_length: 500,
          }
          this.$http.post(this.$store.state.mainAppURL + "orders/get_all_order_of_time_frame/" + this.branch.id, new URLSearchParams(payload).toString()).then(resp => {
            this.orders = resp.data
          });
          this.isHideSpinner = "hide";
          setTimeout(() => {
            $('body').css("padding-right", 0);
          }, 350);
        },
        showOrderDetails(orderId) {
            this.$refs.viewOrderCompNew.fetchOrderDetail(orderId);
        },
    }
}
</script>

<style scoped>

</style>
